export function useEmployeeByDepartmentEmptyField(values: any) {
  return !values?.some((x: string) => !!x);
}
